module.exports = __webpack_public_path__ + "img/lige_p.4b112f21.png";